export enum Role {
  Admin = 'Admin',
  Basic = 'Basic',
  IdentitySuperAdmin = 'IdentitySuperAdmin',
  IdentityBasic = 'IdentityBasic',
  IdentityModerator = 'IdentityModerator'
}